var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 16,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V16H23V1Z",
    fill: "#002B7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9987 1H8.33203V16H22.9987V1Z",
    fill: "#FCD116"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0013 1H15.668V16H23.0013V1Z",
    fill: "#CE1126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRon);
export default __webpack_public_path__ + "static/media/RON.f7461571d9671ea662f613f8c3ad014b.svg";
export { ForwardRef as ReactComponent };